/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import flat from "flat";
import {
  Stepper,
  Container,
  Paper,
  Group,
  Title,
  Text,
  Badge,
  Divider,
  LoadingOverlay,
  ThemeIcon,
} from "@mantine/core";

import { IconFileText, IconCircleCheck } from "@tabler/icons-react";

import { useForm } from "@mantine/form";
import { useLocation } from "react-router-dom";
// import { subDays, formatISO } from 'date-fns/esm';
// import { addDays } from 'date-fns/esm';
// import { formatISO, subDays, addDays } from 'date-fns';
import { subDays, addDays, parseISO } from "date-fns/esm";
import AgreementForm1 from "./AgreementForm1";
import {
  createAgreement,
  getAgreementDetails,
  getAgreementTitleApi,
  getAgreementTypesApi,
  getRegisterUserApi,
  updateAgreement,
} from "../../utilities/apis/agreements";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import { loadingStates } from "../../utilities/utilities";
import AgreementForm2 from "./AgreementForm2";
import AgreementForm3 from "./AgreementForm3";
import AgreementForm4 from "./AgreementForm4";
import colors, { themeColor } from "../../utilities/design";
import AgreementForm5 from "./AgreementForm5";
import AgreementDetail from "../../components/AgreementDetail/AgreementDetail";
import { useSearchParams } from "react-router-dom";
import { addMonths, addYears, differenceInDays } from "date-fns";
const AgreementCreatePage = () => {
  let FORM_STEPS;
  const [searchParams] = useSearchParams();
  const ag = searchParams.get("ag");

  const [flowData, setFlowData] = useState({
    3: [],
    4: [],
    5: [],
    6: [],
    7: [],
    sendfordirectsign: false,
  });

  const initialState = {
    typeOfAgreementData: [],
    typeOfAgreement: null,
    titleOfAgreementData: [],
    titleOfAgreement: null,
    relationshipType: "",
    relationshipWith: ag ? ag : "",
    requestingUser: {
      name: "",
      email: "",
      phone: "",
      designation: "",
      businessDepartment: "",
    },
    dateOfContract: null,
    noOfMonths: null,
    noOfYears: "",
    noOfDays: null,
    dueDateOfContract: null,
    reminderTimeInDays: 15,
    agreementValue: 0,
    contractQuillJsDelta: {
      ops: [{ insert: "Agreement content goes here..." }],
    },
    firstParty: {},
    secondParty: {},
    thirdParty: {},
    fourthParty: {},
    fifthParty: {},
    sixthParty: {},
    seventhParty: {},
    eighthParty: {},
    ninthParty: {},
    tenthParty: {},
    eleventhParty: {},
    twelthParty: {},
    thirteenthParty: {},
    fourteenthParty: {},
    fifteenthParty: {},
    sixteenthParty: {},
    seventeenthParty: {},
    eighteenthParty: {},
    nineteenthParty: {},
    twentythParty: {},
    documents: [],
    formCompleted: false,
    location: null,
    businessUnit: "1",
  };
  const { state } = useLocation();
  const [agreementDetails, setAgreementDetails] = useState({
    agreementLoaded: false,
    agreementId: state?.agreementId || null,
  });
  const [actionText, SetActionText] = useState("draft");
  FORM_STEPS = {
    STEP_1: 0,
    STEP_2: 1,
    STEP_3: 2,
    STEP_4: 3,
    STEP_5: 4,
  };
  const [uiConfigs, setUiConfigs] = useState({
    currentStep: FORM_STEPS.STEP_1,
    loading: loadingStates.NO_ACTIVE_REQUEST,
  });
  const agreementForm = useForm({ initialValues: flat(initialState) });
  const saveAgreement = async (values) => {
    const formValues = flat.unflatten(values || agreementForm.values);

    const agreementData = {
      json: flat.unflatten(values || agreementForm.values),
      flatted: values || agreementForm.values,
    };
    console.log("agreementData: ", agreementData);

    const toUse = agreementDetails.agreementId
      ? updateAgreement
      : createAgreement;

    // const contractMonths = formValues.noOfMonths
    //   ? parseInt(formValues.noOfMonths, 10) * 30
    //   : 0;
    // const contractYears = formValues.noOfYears
    //   ? parseInt(formValues.noOfYears, 10) * 365
    //   : 0;
    // const totalDays = contractMonths + contractYears;

    const startDate = parseISO(formValues.dateOfContract);

    // Build end date (calendar-correct)
    const endDate = formValues.dueDateOfContract
      ? parseISO(formValues.dueDateOfContract)
      : addDays(
          addMonths(
            addYears(startDate, parseInt(formValues.noOfYears || 0, 10)),
            parseInt(formValues.noOfMonths || 0, 10),
          ),
          parseInt(formValues.noOfDays || 0, 10),
        );

    const totalDays = differenceInDays(endDate, startDate) + 1;

    // Safely compute due date only if a contract date exists
    let contractDueDate = null;
    if (formValues.dateOfContract) {
      contractDueDate = addDays(parseISO(formValues.dateOfContract), totalDays);
    }

    // Determine the status based on form completion and current status (normalize to lowercase)
    const currentAction = (actionText || "").toString();
    let newStatus = currentAction || "draft";
    if (formValues.formCompleted && currentAction === "draft") {
      newStatus = "CREATED";
    }
    const agreementArgs = {
      typeOfAgreement: formValues.typeOfAgreement,
      titleOfAgreement: formValues.titleOfAgreement,
      requestingUserDetails: formValues.requestingUser,
      dateOfContract: formValues.dateOfContract,
      contractTermInDays: totalDays,
      noOfYears: parseInt(formValues.noOfYears, 10),
      noOfMonths: parseInt(formValues.noOfMonths, 10),
      noOfMonths: parseInt(formValues.noOfMonths, 10),
      agreementValue: parseInt(formValues.agreementValue, 10),
      location: formValues.location,
      reminderTimeInDays: parseInt(formValues.reminderTimeInDays, 10),
      // dueDateOfContract: contractDueDate,
      dueDateOfContract: endDate,

      reminderTime:
        contractDueDate && formValues.reminderTimeInDays
          ? subDays(contractDueDate, formValues.reminderTimeInDays)
          : null,
      contractQuillJsDelta: formValues.contractQuillJsDelta,
      firstParty: formValues.firstParty,
      secondParty: formValues.secondParty,
      thirdParty: formValues.thirdParty,
      sixthParty: formValues.sixthParty,
      seventhParty: formValues.seventhParty,
      eighthParty: formValues.eighthParty,
      ninthParty: formValues.ninthParty,
      tenthParty: formValues.tenthParty,
      eleventhParty: formValues.eleventhParty,
      twelthParty: formValues.twelthParty,
      thirteenthParty: formValues.thirteenthParty,
      fourteenthParty: formValues.fourteenthParty,
      fifteenthParty: formValues.fifteenthParty,
      sixteenthParty: formValues.sixteenthParty,
      seventeenthParty: formValues.seventeenthParty,
      eighteenthParty: formValues.eighteenthParty,
      nineteenthParty: formValues.nineteenthParty,
      twentythParty: formValues.twentythParty,
      fourthParty: formValues.fourthParty,
      fifthParty: formValues.fifthParty,
      formCompleted: !!formValues.formCompleted,
      relationshipType: formValues.relationshipType,
      relationshipWith: formValues.relationshipWith,
      businessUnit: formValues.businessUnit || "1",
      status: newStatus,
    };

    const args = agreementDetails.agreementId
      ? {
          agreementId: agreementDetails.agreementId,
          agreementData,
          ...agreementArgs,
        }
      : { agreementData, ...agreementArgs };
    setUiConfigs({
      ...uiConfigs,
      loading: loadingStates.LOADING,
    });
    const response = await apiWrapWithErrorWithData(toUse(args));
    if (response?.success) {
      // Update the actionText state when status changes
      if (newStatus !== (actionText || "").toString()) {
        SetActionText(newStatus);
      }

      if (response?.agreement?.id) {
        setAgreementDetails({
          ...agreementDetails,
          agreementId: response.agreement.id,
          agreementLoaded: true,
        });
      }
    } else {
      // showNotification({
      //   color: 'red',
      //   title: 'Agreement Form',
      //   message: 'Something went wrong.',
      // });
      setUiConfigs({
        ...uiConfigs,
        loading: loadingStates.NO_ACTIVE_REQUEST,
      });
      return false;
    }
    setUiConfigs({
      ...uiConfigs,
      loading: loadingStates.NO_ACTIVE_REQUEST,
    });
    return true;
  };

  const fetchAgreementData = async (agreementId) => {
    setUiConfigs({
      ...uiConfigs,
      loading: loadingStates.LOADING,
    });

    const convertResponseToFormValues = (responseAgreement) => ({
      typeOfAgreement: responseAgreement.typeOfAgreement,
      titleOfAgreement: responseAgreement.titleOfAgreement,
      requestingUser: {
        name: "",
        email: "",
        phone: "",
        designation: "",
        businessDepartment: "",
        ...Object.fromEntries(
          Object.entries(responseAgreement.requestingUserDetails || {}).map(
            ([key, value]) => [key, value ?? ""],
          ),
        ),
      },
      dateOfContract: responseAgreement.dateOfContract || null,
      location: responseAgreement.location || null,
      agreementValue: responseAgreement.agreementValue,
      termOfContractInDays: responseAgreement.contractTermInDays || null,
      reminderTime: responseAgreement.reminderTime || null,
      contractQuillJsDelta: responseAgreement.contractQuillJsDelta || {
        ops: [{ insert: "Agreement content goes here..." }],
      },
      firstParty: responseAgreement.firstParty || {},
      secondParty: responseAgreement.secondParty || {},
      thirdParty: responseAgreement.thirdParty || {},
      fourthParty: responseAgreement.fourthParty || {},
      fifthParty: responseAgreement.fifthParty || {},
      sixthParty: responseAgreement.sixthParty || {},
      seventhParty: responseAgreement.seventhParty || {},
      eighthParty: responseAgreement.eighthParty || {},
      ninthParty: responseAgreement.ninthParty || {},
      tenthParty: responseAgreement.tenthParty || {},
      eleventhParty: responseAgreement.eleventhParty || {},
      twelthParty: responseAgreement.twelthParty || {},
      thirteenthParty: responseAgreement.thirteenthParty || {},
      fourteenthParty: responseAgreement.fourteenthParty || {},
      fifteenthParty: responseAgreement.fifteenthParty || {},
      sixteenthParty: responseAgreement.sixteenthParty || {},
      seventeenthParty: responseAgreement.seventeenthParty || {},
      eighteenthParty: responseAgreement.eighteenthParty || {},
      nineteenthParty: responseAgreement.nineteenthParty || {},
      twentythParty: responseAgreement.twentythParty || {},
      formCompleted: !!responseAgreement.formCompleted,
      noOfMonths: responseAgreement.agreementData?.json?.noOfMonths || null,
      noOfYears: responseAgreement.agreementData?.json?.noOfYears || null,
      // noOfDays was historically not persisted at the top level, only inside
      // the agreementData JSON blob (if the user ever touched the Days field).
      noOfDays: responseAgreement.agreementData?.json?.noOfDays || "0",
      dueDateOfContract: responseAgreement.dueDateOfContract || null,
      // reminderTime: responseAgreement.agreementData.json.reminderTime,
      reminderTimeInDays: responseAgreement.reminderTimeInDays || 15,
      relationshipType: responseAgreement.relationshipType,
      relationshipWith: responseAgreement.relationshipWith,
      businessUnit: responseAgreement.bussinessUnit || "1",
    });

    const response = await apiWrapWithErrorWithData(
      getAgreementDetails({ agreementId }),
    );
    if (response?.success && response.agreement) {
      // default to 'draft' if backend returns null/undefined
      SetActionText((response.agreement.actionText || "draft").toString());
      agreementForm.setValues((prevValues) =>
        flat({
          ...initialState,
          ...flat.unflatten(prevValues),
          ...convertResponseToFormValues(response.agreement),
        }),
      );
      setAgreementDetails({
        ...agreementDetails,
        agreementLoaded: true,
      });
      setUiConfigs({
        ...uiConfigs,
        loading: loadingStates.NO_ACTIVE_REQUEST,
      });
    } else {
      // showNotification({
      //   color: 'red',
      //   title: 'Agreement',
      //   message: 'Something went wrong.',
      // });
      setUiConfigs({
        ...uiConfigs,
        loading: loadingStates.NO_ACTIVE_REQUEST,
      });
    }
  };

  const getRegisterUser = async () => {
    const convertResponseForRequestingUser = (response) => ({
      requestingUser: response,
    });
    const res = await apiWrapWithErrorWithData(getRegisterUserApi());
    agreementForm.setValues((prevValues) =>
      flat({
        ...initialState,
        ...flat.unflatten(prevValues),
        ...convertResponseForRequestingUser(res?.requestingUser),
      }),
    );
  };

  useEffect(() => {
    if (agreementDetails.agreementId && !agreementDetails.agreementLoaded) {
      fetchAgreementData(agreementDetails.agreementId);
    }

    if (!agreementDetails.agreementId) {
      getRegisterUser();
    }
  }, [agreementDetails.agreementId, agreementDetails.agreementLoaded]);

  const getAgreementTypes = async () => {
    const resp = await apiWrapWithErrorWithData(getAgreementTypesApi());
    if (resp?.success && resp?.typesOfAgreement) {
      const uniqueValues = Array.from(new Set([...resp.typesOfAgreement]));
      agreementForm.setFieldValue("typeOfAgreementData", uniqueValues);
    } else {
      // showNotification({
      //   title: 'Agreement Types',
      //   message: 'Could not load agreement types',
      //   color: 'red',
      // });
    }
  };

  const getAgreementTitle = async () => {
    const resp = await apiWrapWithErrorWithData(getAgreementTitleApi());
    if (resp?.success && resp?.titlesOfAgreement) {
      const uniqueValues = Array.from(new Set([...resp.titlesOfAgreement]));
      agreementForm.setFieldValue("titleOfAgreementData", uniqueValues);
    } else {
      // showNotification({
      //   title: 'Agreement Title',
      //   message: 'Could not load agreement titles',
      //   color: 'red',
      // });
    }
  };

  useEffect(() => {
    getAgreementTypes();
    getAgreementTitle();
  }, []);

  const allowStepSelect =
    !!agreementForm.values.formCompleted || !!agreementDetails.agreementId;
  console.log("status for agreement", actionText);

  return (
    <Container
      fluid
      px="lg"
      py="md"
      style={{
        maxWidth: 1320,
        margin: "0 auto",
        position: "relative",
      }}
    >
      <Paper withBorder radius="lg" shadow="xs" p="xl" mb="lg">
        <Group justify="space-between" mb="xl">
          <Group gap="md">
            <ThemeIcon size={42} radius="xl" variant="light">
              <IconFileText size={22} />
            </ThemeIcon>

            <div>
              <Title order={3}>
                {agreementDetails.agreementId
                  ? "Edit Contract"
                  : "Create New Contract"}
              </Title>

              <Text c="dimmed" size="sm" style={{textTransform:"none", color:"GrayText"}}>
                {agreementDetails.agreementId
                  ? "Edit, review and manage contracts through a guided workflow."
                  : "Create, review and manage contracts through a guided workflow."}
              </Text>
            </div>
          </Group>

          <Badge
            size="lg"
            color={agreementDetails.agreementId ? "green" : "blue"}
            variant="light"
          >
            {agreementDetails.agreementId ? "Editing Contract" : "New Contract"}
          </Badge>
        </Group>
      </Paper>

      <div style={{ position: "relative" }}>
        <LoadingOverlay visible={uiConfigs.loading === loadingStates.LOADING} />
        <Paper
          withBorder
          shadow="xs"
          radius="xl"
          p="xl"
          style={{
            height: "auto",
            minHeight: "unset",
          }}
        >
          <Stepper
            active={uiConfigs.currentStep}
            color={themeColor(colors.agreement)}
            iconSize={36}
            size="md"
            radius="xl"
            completedIcon={<IconCircleCheck size={18} />}
            allowNextStepsSelect={allowStepSelect}
            active={uiConfigs.currentStep}
            onStepClick={(step) => {
              setUiConfigs({
                ...uiConfigs,
                currentStep: step,
              });
            }}
            style={{
              paddingTop: 8,
              paddingBottom: 24,
            }}
            // iconSize={{window.innerWidth} < 850 ? 1 : 30}
            // size="20"
          >
            <Stepper.Step
              label="Key Information"
              allowStepSelect={allowStepSelect}
              description="Basic Details"
            >
              <div
                style={{
                  marginTop: 24,
                  background: "#FAFBFC",
                  borderRadius: 12,
                  padding: 24,
                }}
              >
                <AgreementForm1
                  id={agreementDetails.agreementId}
                  save={saveAgreement}
                  uiConfigs={uiConfigs}
                  setUiConfigs={setUiConfigs}
                  form={agreementForm}
                />
              </div>
            </Stepper.Step>

            <Stepper.Step
              allowStepSelect={allowStepSelect}
              label="Terms & Duration"
              description="Validity"
            >
              <div
                style={{
                  marginTop: 24,
                  background: "#FAFBFC",
                  borderRadius: 12,
                  padding: 24,
                }}
              >
                <AgreementForm2
                  id={agreementDetails.agreementId}
                  save={saveAgreement}
                  uiConfigs={uiConfigs}
                  setUiConfigs={setUiConfigs}
                  form={agreementForm}
                  initialState={initialState}
                />
              </div>
            </Stepper.Step>

            <Stepper.Step
              allowStepSelect={allowStepSelect}
              label="Contract Parties"
              description="Stakeholders"
            >
              <div
                style={{
                  marginTop: 24,
                  background: "#FAFBFC",
                  borderRadius: 12,
                  padding: 24,
                }}
              >
                <AgreementForm3
                  flowData={flowData}
                  setFlowData={setFlowData}
                  actionText={actionText}
                  id={agreementDetails.agreementId}
                  save={saveAgreement}
                  uiConfigs={uiConfigs}
                  setUiConfigs={setUiConfigs}
                  form={agreementForm}
                  initialState={initialState}
                />
              </div>
            </Stepper.Step>

            <Stepper.Step
              allowStepSelect={allowStepSelect}
              label="Roles & Permissions"
              description="Approvals"
            >
              <div
                style={{
                  marginTop: 24,
                  background: "#FAFBFC",
                  borderRadius: 12,
                  padding: 24,
                }}
              >
                <AgreementForm5
                  flowData={flowData}
                  setFlowData={setFlowData}
                  id={agreementDetails.agreementId}
                  save={saveAgreement}
                  uiConfigs={uiConfigs}
                  setUiConfigs={setUiConfigs}
                  form={agreementForm}
                  initialState={initialState}
                />
              </div>
            </Stepper.Step>

            <Stepper.Step
              allowStepSelect={allowStepSelect}
              label="Content"
              description="Document"
            >
              <div
                style={{
                  marginTop: 24,
                  background: "#FAFBFC",
                  borderRadius: 12,
                  padding: 24,
                }}
              >
                <AgreementForm4
                  id={agreementDetails.agreementId}
                  save={saveAgreement}
                  uiConfigs={uiConfigs}
                  setUiConfigs={setUiConfigs}
                  form={agreementForm}
                />
              </div>
            </Stepper.Step>
          </Stepper>
        </Paper>
      </div>
    </Container>
  );
};

export default AgreementCreatePage;
